import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

const RECAPTCHA_SITE_KEY = '6LeVbmktAAAAAF_aQlkhAvBKH8DVI7RWzH6MNrOG';

const GoogleReCaptcha = forwardRef(({ onVerify, onExpire }, ref) => {
  const scriptLoaded = useRef(false);

  useImperativeHandle(ref, () => ({
    execute: async () => {
      if (!window.grecaptcha || !window.grecaptcha.execute) {
        console.warn('reCAPTCHA not loaded yet');
        return null;
      }
      try {
        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
          action: 'login'
        });
        if (token && onVerify) onVerify(token);
        return token;
      } catch (err) {
        console.error('reCAPTCHA execute error:', err);
        return null;
      }
    }
  }));

  useEffect(() => {
    // Load reCAPTCHA v3 script if not already loaded
    if (document.querySelector(`script[src*="recaptcha/api.js"]`)) {
      scriptLoaded.current = true;
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      scriptLoaded.current = true;
    };

    return () => {
      // Cleanup not needed
    };
  }, []);

  // No visible UI - reCAPTCHA v3 runs silently in the background
  return null;
});

export default GoogleReCaptcha;